import type { CSSProperties } from "react";

/**
 * O `Skeleton` e o `Toast` do Prime 10.9.8 ignoram a prop `style` da raiz (ela só chega por `pt.root`): leva o `style` da
 * tela para `pt.root.style`, sem apagar o `pt` dela (o `style` do `pt` vence). `pt.root` em formato de função fica como a tela passou.
 */
export function rootStylePt<P extends { root?: unknown }>(
  pt: P | undefined,
  style: CSSProperties | undefined,
): P | undefined {
  if (!style) return pt;
  const root = pt?.root;
  if (typeof root === "function") return pt;
  const own = (root ?? {}) as { style?: CSSProperties };
  return { ...pt, root: { ...own, style: { ...style, ...own.style } } } as P;
}
